import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/navigation/icons/x-close@2x.png'
import _imports_1 from '@/assets/_svg/icon-save.svg'


const _hoisted_1 = { class: "modal-window user-settings" }
const _hoisted_2 = { class: "user-settings-header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "icon-close"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "user-settings-avatar" }
const _hoisted_6 = ["href"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "user-settings-avatar--edit" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1.6463,14.353A.4962.4962,0,0,0,2,14.5a.5939.5939,0,0,0,.138-.018l4.199-1.2.0078-.0026a.121.121,0,0,0,.0232-.0094l.04-.017a.4819.4819,0,0,0,.146-.099l7.179-7.179a2.622,2.622,0,0,0-3.708-3.708L2.8463,9.446a.4949.4949,0,0,0-.1.147l-.009.02.001-.001a.4291.4291,0,0,0-.019.05l-1.2,4.2A.5.5,0,0,0,1.6463,14.353Zm3.6-1.8-2.518.719.72-2.517Zm.954-.46,5.572-5.572L9.4793,4.228,3.9073,9.8Zm6.826-6.826-.547.547-2.293-2.293.547-.547a1.6236,1.6236,0,0,1,2.293,0A1.6236,1.6236,0,0,1,13.0263,5.267Z",
      "fill-rule": "evenodd"
    })
  ])
], -1)
const _hoisted_9 = { class: "user-settings-name" }
const _hoisted_10 = { class: "user-settings-email" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_12 = { class: "user-settings-body" }
const _hoisted_13 = {
  key: 0,
  class: "user-setting-input"
}
const _hoisted_14 = ["for"]
const _hoisted_15 = ["id", "placeholder"]
const _hoisted_16 = {
  key: 0,
  class: "user-setting-input-error"
}
const _hoisted_17 = { class: "user-setting-input" }
const _hoisted_18 = ["for"]
const _hoisted_19 = ["id", "placeholder"]
const _hoisted_20 = {
  key: 0,
  class: "user-setting-input-error"
}
const _hoisted_21 = { class: "user-setting-input" }
const _hoisted_22 = ["for"]
const _hoisted_23 = ["id", "placeholder"]
const _hoisted_24 = {
  key: 0,
  class: "user-setting-input-error"
}
const _hoisted_25 = { class: "user-setting-input" }
const _hoisted_26 = ["for"]
const _hoisted_27 = ["id", "placeholder"]
const _hoisted_28 = {
  key: 0,
  class: "user-setting-input-error"
}
const _hoisted_29 = { class: "user-setting-dropdown-label" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "user-setting-dropdown-action" }, null, -1)
const _hoisted_31 = { class: "user-setting-dropdown-list" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "user-setting-dropdown-label" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "user-setting-dropdown-action" }, null, -1)
const _hoisted_35 = { class: "user-setting-dropdown-list" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = { class: "section-label" }
const _hoisted_38 = ["for"]
const _hoisted_39 = { class: "user-settings-privacy" }
const _hoisted_40 = ["href"]
const _hoisted_41 = ["href"]
const _hoisted_42 = { class: "user-settings-version" }
const _hoisted_43 = { class: "user-setting-buttons-bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_button = _resolveComponent("my-button")!
  const _component_user_property = _resolveComponent("user-property")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({ 'modal-overlay': true, mobile: _ctx.isMobile && _ctx.isUserModalVisible })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "modal-close icon-small",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, _hoisted_4),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            href: `https://${_ctx.serverLocale}.gravatar.com/emails`,
            rel: "external",
            target: "_blank"
          }, [
            _createElementVNode("img", {
              class: "user-settings-avatar--image",
              src: _ctx.userPictureUrl,
              alt: "user-image"
            }, null, 8, _hoisted_7),
            _hoisted_8
          ], 8, _hoisted_6)
        ]),
        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.username), 1),
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.email), 1),
        _createVNode(_component_my_button, {
          class: "user-settings-header-btn",
          onClick: _withModifiers(_ctx.saveChanges, ["prevent"])
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userSettings.switch, (setting, index) => {
          return (_openBlock(), _createBlock(_component_user_property, {
            key: index,
            checked: setting.value,
            "onUpdate:checked": ($event: any) => ((setting.value) = $event),
            hidden: setting.hidden,
            "onUpdate:hidden": ($event: any) => ((setting.hidden) = $event),
            "field-id": _ctx.$t(`pages.maps.user_settings.${setting.name}.placeholder`),
            value: setting.name
          }, null, 8, ["checked", "onUpdate:checked", "hidden", "onUpdate:hidden", "field-id", "value"]))
        }), 128)),
        (_ctx.userSettings.switch[1].value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("label", {
                for: _ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceGroupingNumber.name}.label`)
              }, _toDisplayString(_ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceGroupingNumber.name}.label`)), 9, _hoisted_14),
              _withDirectives(_createElementVNode("input", {
                id: _ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceGroupingNumber.name}.label`),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userSettings.deviceGroupingNumber.value) = $event)),
                placeholder: 
                            _ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceGroupingNumber.name}.placeholder`)
                        ,
                type: "number"
              }, null, 8, _hoisted_15), [
                [_vModelText, _ctx.userSettings.deviceGroupingNumber.value]
              ]),
              (_ctx.userSettings.deviceGroupingNumber.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceGroupingNumber.name}.error`)), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", {
            for: _ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.refreshInterval.name}.label`)
          }, _toDisplayString(_ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.refreshInterval.name}.label`)), 9, _hoisted_18),
          _withDirectives(_createElementVNode("input", {
            id: _ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.refreshInterval.name}.label`),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userSettings.refreshInterval.value) = $event)),
            placeholder: _ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.refreshInterval.name}.placeholder`),
            type: "number"
          }, null, 8, _hoisted_19), [
            [_vModelText, _ctx.userSettings.refreshInterval.value]
          ]),
          (_ctx.userSettings.refreshInterval.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.refreshInterval.name}.error`)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("label", {
            for: _ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceInactiveTime.name}.label`)
          }, _toDisplayString(_ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceInactiveTime.name}.label`)), 9, _hoisted_22),
          _withDirectives(_createElementVNode("input", {
            id: _ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceInactiveTime.name}.label`),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userSettings.deviceInactiveTime.value) = $event)),
            placeholder: 
                            _ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceInactiveTime.name}.placeholder`)
                        ,
            type: "number"
          }, null, 8, _hoisted_23), [
            [_vModelText, _ctx.userSettings.deviceInactiveTime.value]
          ]),
          (_ctx.userSettings.deviceInactiveTime.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceInactiveTime.name}.error`)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("label", {
            for: _ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceWithoutContactTime.name}.label`)
          }, _toDisplayString(_ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceWithoutContactTime.name}.label`)), 9, _hoisted_26),
          _withDirectives(_createElementVNode("input", {
            id: _ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceWithoutContactTime.name}.label`),
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userSettings.deviceWithoutContactTime.value) = $event)),
            placeholder: 
                            _ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceWithoutContactTime.name}.placeholder`)
                        ,
            type: "number"
          }, null, 8, _hoisted_27), [
            [_vModelText, _ctx.userSettings.deviceWithoutContactTime.value]
          ]),
          (_ctx.userSettings.deviceWithoutContactTime.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceWithoutContactTime.name}.error`)), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t(`pages.maps.user_settings.default_map_settings.label`)), 1),
        _createElementVNode("div", {
          class: _normalizeClass({
                        'user-setting-dropdown': true,
                        'user-setting-dropdown--open': _ctx.mapSettingsOpen,
                    })
        }, [
          _createElementVNode("div", {
            class: "user-setting-dropdown-current",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.mapSettingsOpen = !_ctx.mapSettingsOpen))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mapSettingsList.filter(
                                (settings) => settings.name === _ctx.currentDefaultMapSettings,
                            ), (mapSettings) => {
              return (_openBlock(), _createElementBlock("button", {
                key: mapSettings.id
              }, _toDisplayString(_ctx.$t(`pages.maps.devices_map.settings.${mapSettings.name}`)), 1))
            }), 128)),
            _hoisted_30
          ]),
          _createElementVNode("div", _hoisted_31, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mapSettingsList.filter(
                                (settings) => settings.name !== _ctx.currentDefaultMapSettings,
                            ), (mapSettings) => {
              return (_openBlock(), _createElementBlock("button", {
                key: mapSettings.id,
                onClick: ($event: any) => (_ctx.changeDefaultMapSettings(mapSettings.name))
              }, _toDisplayString(_ctx.$t(`pages.maps.devices_map.settings.${mapSettings.name}`)), 9, _hoisted_32))
            }), 128))
          ])
        ], 2),
        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t(`pages.maps.user_settings.languages.label`)), 1),
        _createElementVNode("div", {
          class: _normalizeClass({
                        'user-setting-dropdown': true,
                        'user-setting-dropdown--open': _ctx.languageSettingsOpen,
                    })
        }, [
          _createElementVNode("div", {
            class: "user-setting-dropdown-current",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.languageSettingsOpen = !_ctx.languageSettingsOpen))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localesList.filter((locale) => locale.code === _ctx.currentLanguage), (locale) => {
              return (_openBlock(), _createElementBlock("button", {
                key: locale.code
              }, _toDisplayString(_ctx.$t(`pages.maps.user_settings.languages.${locale.code}`)), 1))
            }), 128)),
            _hoisted_34
          ]),
          _createElementVNode("div", _hoisted_35, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localesList.filter((locale) => locale.code !== _ctx.currentLanguage), (locale) => {
              return (_openBlock(), _createElementBlock("button", {
                key: locale.code,
                onClick: ($event: any) => (_ctx.changeLanguage(locale.code))
              }, _toDisplayString(_ctx.$t(`pages.maps.user_settings.languages.${locale.code}`)), 9, _hoisted_36))
            }), 128))
          ])
        ], 2),
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("label", {
            for: _ctx.$t(`pages.maps.user_settings.${_ctx.userSettings.deviceGroupingNumber.name}.label`)
          }, _toDisplayString(_ctx.$t(`pages.maps.user_settings.toolbar.label`)), 9, _hoisted_38)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userSettings.toolbar, (setting, index) => {
          return (_openBlock(), _createBlock(_component_user_property, {
            key: index,
            checked: setting.value,
            "onUpdate:checked": ($event: any) => ((setting.value) = $event),
            hidden: setting.hidden,
            "onUpdate:hidden": ($event: any) => ((setting.hidden) = $event),
            icon: setting.icon,
            "field-id": _ctx.$t(`pages.maps.user_settings.${setting.name}.placeholder`),
            value: setting.name
          }, null, 8, ["checked", "onUpdate:checked", "hidden", "onUpdate:hidden", "icon", "field-id", "value"]))
        }), 128)),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("a", {
            href: _ctx.$t('pages.maps.user_settings.impressum.url'),
            target: "_blank"
          }, _toDisplayString(_ctx.$t('pages.maps.user_settings.impressum.label')), 9, _hoisted_40),
          _createElementVNode("a", {
            href: _ctx.$t('pages.maps.user_settings.privacy.url'),
            target: "_blank"
          }, _toDisplayString(_ctx.$t('pages.maps.user_settings.privacy.label')), 9, _hoisted_41),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openTermsAndConditionsModal && _ctx.openTermsAndConditionsModal(...args)))
          }, _toDisplayString(_ctx.$t('pages.maps.user_settings.terms_and_conditions.label')), 1)
        ]),
        _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t(`pages.maps.user_settings.version.label`)) + ": " + _toDisplayString(_ctx.version), 1)
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createVNode(_component_my_button, {
          onClick: _withModifiers(_ctx.saveChanges, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(`components.modal.close`)), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ], 2))
}